export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div
      className={`relative flex overflow-hidden ${className}`}
      aria-hidden="true"
      data-testid="community-marquee"
    >
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display whitespace-nowrap px-8 text-4xl font-light tracking-tight text-[color:var(--ink)] sm:text-5xl md:text-6xl">
              {item}
            </span>
            <span className="brand-bar h-2 w-2 rounded-full" />
          </div>
        ))}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[color:var(--paper)] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[color:var(--paper)] to-transparent" />
    </div>
  );
}
